import { Component, Inject, OnInit, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { DateTime } from "luxon";
import { TicketService } from "../../../services/ticket.service";
import {
  MateraTransferReleaseResponse,
  Transferencias,
} from "../../../model/domain/Matera";

@Component({
  selector: "app-eletronic-transfer-releases-dialog",
  templateUrl: "./eletronic-transfer-releases-dialog.component.html",
  styleUrls: ["./eletronic-transfer-releases-dialog.component.css"],
})
export class EletronicTransferReleasesDialogComponent {
  form: FormGroup;

  bankAccount: string;
  operationDate: DateTime;

  materaReleases: MateraTransferReleaseResponse =
    new MateraTransferReleaseResponse();
  transfers: Transferencias[];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private service: TicketService
  ) {
    this.bankAccount = data.bankAccount;
    this.operationDate = data.operationDate;

    this.getReleases();
  }

  getReleases() {
    this.service
      .getEletronicTransferReleases(this.bankAccount, this.operationDate)
      .subscribe((q) => {
        this.materaReleases = q;
        this.transfers = this.materaReleases.result.transferencias;
      });
  }
}
